import { z } from 'zod'

import { labelAndValue, paginationSchema, sortingSchema } from '@/utils/zod'

import { curriculumAim } from './curriculum-schemas'

export const curriculumsManagementFiltersSchema = z.object({
  curriculum: z.array(labelAndValue()).optional(),
  educationLevel: z.array(labelAndValue()).optional(),
  aim: z.array(curriculumAim).optional(),
  ...paginationSchema.shape,
  ...sortingSchema.shape
})

export type CurriculumsManagementFilters = z.infer<
  typeof curriculumsManagementFiltersSchema
>

export type CurriculumsManagementFiltersKey = keyof CurriculumsManagementFilters
